import { Injectable } from '@angular/core';

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem('access_token');

    if (token && !request.url.includes('githubusercontent.com/dmijares23')) {
      return next.handle(
        request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        }),
      );
    }

    return next.handle(request);
  }
}
